import React from 'react';
import PropTypes from 'prop-types';
import usePersonConditions from 'src/common/hooks/usePersonConditions';
import ClientNeedForm from 'src/common/display/SingleItemDetails/ClientNeedForm';
import ModalEditForm from 'src/common/modal/ModalEditForm';

const ClientNeed = ({
 contact, editable, clientNeed, caseId, reloadCase, currentEmployeeId,
}) => {
  const conditions = usePersonConditions(contact?.id, true);

  const selectedCondition = conditions.find((condition) => condition.id === clientNeed?.id);

  return (
    <div className="mt-2 mb-4 grid grid-cols-12">
      <div className="col-span-10 p-0">
        <h5 className="mb-3">Client Need</h5>
        <div>{selectedCondition?.name}</div>
      </div>
      <div className="col-span-2 p-0">
        <ModalEditForm
          id="edit-detail-description-modal"
          buttonId="edit-detail-description"
          header="Edit Associated Need"
          size="large"
          showEdit={editable}
          labelText="Edit"
        >
          <ClientNeedForm
            selectedConditionId={selectedCondition?.id}
            conditions={conditions}
            caseId={caseId}
            reloadCase={reloadCase}
            currentEmployeeId={currentEmployeeId}
          />
        </ModalEditForm>
      </div>
    </div>
  );
};

ClientNeed.propTypes = {
  contact: PropTypes.object.isRequired,
  editable: PropTypes.bool.isRequired,
  clientNeed: PropTypes.object.isRequired,
  caseId: PropTypes.string.isRequired,
  reloadCase: PropTypes.func.isRequired,
  currentEmployeeId: PropTypes.string.isRequired,
};

export default ClientNeed;
